import { useState } from 'react';
import { useGetDashboardStats } from '../../../apis/dashboard/get-dashboard-stats';
import { useGetExtendedStats } from '../../../apis/dashboard/get-extended-stats';
import { useFilterExtendedStats } from '../../../apis/dashboard/filter-extended-stats';


const useMainDashboard = () => {

    const [filter, setFilter] = useState("all");

    const { data: allStats, isFetching: allStatsLoading } = useGetDashboardStats();
    const { data: extendedStats, isFetching: extendedStatsLoading } = useGetExtendedStats();
    const { data: filteredStats, isFetching: filteredStatsLoading } = useFilterExtendedStats(filter);

    const isLoading = allStatsLoading || extendedStatsLoading;

    const handleFilter = (value: string) => setFilter(value);

    return {
        allStats,
        extendedStats,
        filteredStats,
        isLoading,
        filteredStatsLoading,
        filter,
        handleFilter,
    }
};

export default useMainDashboard;